import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { i18nPlugin } from "./plugins/i18n";
// Self-hosted webfonts:统一走 @brood/fonts(RFC-0081);原 @fontsource 直引已取代。
import "@brood/fonts/all.css";
import "./style.css";

// Pinia was removed alongside ``stores/software.ts`` — it was the only
// store and both views (Software, Dashboard) had already migrated to
// calling the API client directly because ``useSoftwareStore()`` crashed
// at mount time. If we add a store back later, also re-add ``createPinia``
// here.

const app = createApp(App);
app.use(router);
app.use(i18nPlugin);
app.mount("#app");
